import React from 'react';
import DetailsClearance from './DetailsClearance';

const StatesDetails = ({ clearing = {}, setlist = '' }) => {
    return (
        <React.Fragment>
            <div className="ckp-entry-details-clearance">
                <DetailsClearance clearing={clearing} />
            </div>
            <span className="ckp-modal-full-line is-sub" />
            {setlist && (
                <div className="ckp-entry-details-clearance">
                    <p className="ckp-entry-details-label">Setlist</p>
                    <div className="ckp-entry-details-field ckp-entry-details-field--setlist">
                        {setlist.split(/\n/).map((line, i) => (
                            <p key={i}>{line || ''}</p>
                        ))}
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};

export default StatesDetails;
